<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-6">{{ sectionData.name }}</h2>
      <p class="mb-12 text-gray-600">{{ sectionData.description }}</p>
      <TheButton
        v-if="sectionData.link"
        class="mb-6 w-[180px]"
        :to="sectionData.link?.url"
        :title="sectionData.link?.name || ''"
      >
        <span class="text-sm">{{ sectionData.link?.name }}</span>
      </TheButton>
      <CarouselPartners :carousel-list="contextTrustedPartners" />
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISection } from '@/assets/types/api/Pages';
  import type { IPartnersItem } from '@/assets/types/api/Partners';
  import type { IPartnersCarousel } from '@/components/Shared/Carousel/types';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });

  const partnersStore = usePartnersStore();
  const { trustedPartners } = storeToRefs(partnersStore);

  const contextTrustedPartners = computed((): IPartnersCarousel[] => {
    return trustedPartners.value.map((item: IPartnersItem) => ({
      name: item.name,
      description: item.description,
      imageUrl: item.imageUrl,
      focusedSolutions: [...item.focusedSolutions],
    }));
  });
</script>
